import React from "react";
import { getRootPath } from "userful-chronos-app-common-js/dist/routing";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";
import "./HTTPError.scss";

interface IProps {}
export default function HTTPError(props: IProps) {
    const { t } = useTranslation();

    return (
        <div className="httpError">
            <FontAwesomeIcon icon={faExclamationCircle} style={{ color: " #D13E2C", marginRight: "8px" }} />
            {t("CommonUI.Config.Https.httpsRequired1")}
            &nbsp;
            <a href={`${getRootPath()}setup`}>Setup</a>
            &nbsp;
            {t("CommonUI.Config.Https.httpsRequired2")}
        </div>
    );
}
